import styled from "@emotion/styled";
import React from "react";
const SocialsDiv = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 0 100px 0;

  align-items: center;
`;
const Socials = styled.div`
  background-color: white;
  display: flex;
  justify-content: space-between;
  border-radius: 30px;

  align-items: center;
`;
const SocialLink = styled.a`
  text-decoration: none;
  font-family: "Poppins-Medium";
  padding: 0px 30px;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 30px;
  color: black;
  transition: 0.3s;
  @media screen and (max-width: 399px) {
    padding: 0px 16px;
  }
  &:hover {
    color: #fff;
    /* border: 1px solid #fff; */
    background-color: rgb(0, 0, 0);
  }
`;
const Footer = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  padding: 20px 0;
  text-align: center;

  font-family: "Poppins-Regular";
`;
const index = () => {
  return (
    <div>
      <SocialsDiv data-aos="fade-up" data-aos-duration="1000">
        {/* <Socials>
          <SocialLink href="https://twitter.com/ProofofApeETH" target="blank">
            TWITTER
          </SocialLink>
          <SocialLink href="https://t.me/proofofape" target="blank">
            TELEGRAM
          </SocialLink>
          <SocialLink
            href="https://medium.com/@zaffre_73091/apecoin-2-0-4d3abad58339"
            target="blank"
          >
            MEDIUM
          </SocialLink> */}
        {/* </Socials> */}
      </SocialsDiv>
      <Footer>Copyright © 2022 Proofofapecoin</Footer>
    </div>
  );
};

export default index;
